<template>
  <el-row v-if="EVENT_TYPES && initiator && entity" @mouseover="setView">
    <el-col :span="4">
      <user-avatar :userId="initiator.id" :factor="1.5"></user-avatar>
    </el-col>
    <el-col :span="20" class="notify-info">
      <template v-if="item.eventType == EVENT_TYPES.GroupInvite">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            приглашает вас в группу:</span
          >
          <br />
          <span v-if="entityId != undefined && entityId != null"
            ><router-link
              class="selected-text"
              :to="{ name: 'Group', params: { id: entity.id } }"
              >{{ entity.name }}
            </router-link></span
          >
          <br />
          <button-view
            v-if="item.eventType == EVENT_TYPES.GroupInvite && !isMember && showBtn"
            style="margin-top:10px;"
            @clickAction="acceptGroupInvite()"
            :borderRadius="'0px 5px'"
            :width="153"
            :height="32"
            >Присоединится</button-view
          >
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.NewFriendRequest">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            добавил вас в друзья</span
          >
          <span>{{ getCommonFriendsCount(initiator) }}</span>
          <br />
          <button-view
          v-if="isFriend(initiator.id)"
          class="alternative-btn"
          style="margin-top:10px;"
          :borderRadius="'0px 5px'"
          :color="'#006EFF'"
          :width="153"
          :height="32"
          >Уже друзья</button-view
        >
          <button-view
            style="margin-top:10px;"
            @clickAction="notifyAction(acceptFriendship(initiator.id))"
            :borderRadius="'0px 5px'"
            :width="153"
            :height="32"
            >Добавить в друзья</button-view
          >
          
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.LikePost">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            оценил ваш пост:</span
          >
          <br />
          <span class="selected-text limited-text" v-if="entity">{{
            `"${entity.massage}"`
          }}</span>
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.LikePhoto">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            оценил вашу фотографию</span
          >
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.LikeAvatar">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            оценил ваш аватар</span
          >
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.CommentPhoto">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            прокоментировал вашу фотографию</span
          >
          <br />
          <span class="selected-text limited-text" v-if="entity">{{
            `"${entity.message}"`
          }}</span>
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.CommentReply">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            прокоментировал ваш ответ</span
          >
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.LikeComment">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            оценил ваш комментарий:
          </span>
          <br />
          <span class="selected-text limited-text" v-if="entity">{{
            `"${entity.message}"`
          }}</span>
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.CommentPost">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            прокоментировал ваш пост:</span
          >
          <br />
          <span class="selected-text limited-text" v-if="entity">{{
            `"${entity.message}"`
          }}</span>
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.FriendRequestApproval">
        <div>
          <span>
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
            принял ваш запрос о дружбе
          </span>
        </div>
      </template>
      <template v-if="item.eventType == EVENT_TYPES.MissedCall">
        <div>
          <span>
            Вы пропустили звонок от
            <router-link
              class="selected-text"
              :to="{ name: 'Profile', params: { id: initiator.id } }"
              >{{ initiator.name + " " + initiator.surName }}</router-link
            >
          </span>
        </div>
      </template>
    </el-col>
  </el-row>
</template>

<script>
import { EVENT_TYPES } from "@/constants.js";
import UserAvatar from "@/components/avatars/UserAvatar";
import relationshipMixins from "@/mixins/relationship-mixins";
import buttonView from "@/components/Common/UI/buttonView.vue";
import {mapGetters} from "vuex";
export default {
  mixins: [relationshipMixins],
  components: {
    UserAvatar,
    buttonView,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      EVENT_TYPES: EVENT_TYPES,
      initiator: null,
      entity: {},
      entityParent: null,
      viewed: null,
      showBtn: true
    };
  },
  async created() {
    await this.getInitiator();
    if (this.item.eventType == EVENT_TYPES.GroupInvite) await this.getGroup();
    if (this.item.eventType == EVENT_TYPES.LikePost) this.getPost();
    if (
      this.item.eventType == EVENT_TYPES.CommentPost ||
      this.item.eventType == EVENT_TYPES.LikeComment ||
      this.item.eventType == EVENT_TYPES.CommentPhoto
    )
      this.getComment();
    this.viewed = this.item.viewed;
    //if (this.item.eventType == EVENT_TYPES.LikePhoto) this.getPhoto();
  },
  computed: {
    ...mapGetters("context", ["currentUserId"]),
    entityId() {
      return this.entity == null? undefined:this.entity.id;
    },
    isMember(){
      if (this.item.eventType == EVENT_TYPES.GroupInvite && this.entity.members !=  null)
        return this.entity.members.some((x) => x.id == this.currentUserId)
      return false
    }
  },
  methods: {
    async acceptGroupInvite() {
      await this.$http.get("Group/Join?groupId=" + this.entity.id);
      this.$router.push({name: 'Group', params: { id: this.entity.id }})
      this.showBtn=false;
    },
    async getGroup() {
      this.entity = (
        await this.$http.get("Group/Get?groupId=" + this.item.eventEntityId)
      ).data;
    },
    async setView() {
      if (!this.viewed) {
        await this.$http.patch("api/EventNotification/view", {
          eventNotificationIds: [this.item.eventEntityId],
          setViewedAllUserNotifications: true,
        });
        this.viewed = true;
        this.$hub.updateNotifications(this.currentUserId);
      }
    },
    async getComment() {
      this.entity = (
        await this.$http.get("Comment?id=" + this.item.eventEntityId)
      ).data;
    },
    async getPhoto() {
      this.entity = (
        await this.$http.get("Photo?id=" + this.item.eventEntityId)
      ).data;
    },
    async getPost() {
      this.entity = (
        await this.$http.get("Post?id=" + this.item.eventEntityId)
      ).data;
      if (this.entity.parentPostId != null && this.entity.parentPostId != "")
        this.entityParent = (
          await this.$http.get("Post?id=" + this.entity.parentPostId)
        ).data;
    },
    async getInitiator() {
      this.initiator = (
        await this.$http(
          "Profile/GetUserProfile?userId=" + this.item.details[0].initiatorId
        )
      ).data;
    },
  },
};
</script>
<style scoped>
</style>
<style>
.notify-info a {
  font-family: "Lato" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 15px !important;
  display: inline !important;
  line-height: 22px;
  text-align: left !important;
}
.notify-info {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: var(--textGeneralColor);
  text-align: left;
}
.limited-text {
  display: inline-block;
  white-space: nowrap;
  width: 280px;
  overflow: hidden !important;
  text-overflow: ellipsis;
  line-height: 22px;
}
.selected-text {
  color: var(--blueColor) !important;
}
</style>
